module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": _vm.alert.color,
      "icon": _vm.alert.icon,
      "dismissible": ""
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.alert.message({
        label: _vm.label,
        txHash: _vm.txHash,
        error: _vm.error,
        network: _vm.network
      }))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac07156"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/TransactionNotify.vue
// module id = 261
// module chunks = 1